import React from 'react'
import './truckinginsurance.scss'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, MainTextImage, FindAgent, CommonList, FigureCards, NewsCard, SuccessStories, CommonBlueCards, VideoPlayer } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const TruckingInsurance = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/whoweserve" },
    { label: "Trucking insurance", link: "/whoweserve/truckinginsurance" },
  ];

  const HeaderData = [
    {
      para: 'You’re focused on trucking. We’re focused on trucking insurance. At Sentry, we understand that every business is unique. Whether you’re an owner-operator or you manage a large fleet, we’ll get to know your business so we can provide the coverage that’s right for you.',
    },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const Datalist = [
    "Flexible coverage options",
    "Knowledgeable claims staff who understand trucking",
    "Certified directors of safety with more than 20 years of industry experience",
  ];

  const revenueData = [
    {
      id: 1,
      value: "33",
      unit: "Years",
      description: "Sentry Insurance Group has received an A+ rating from AM Best for 33 years in a row.*",
    },
    {
      id: 2,
      value: "65",
      unit: "Agencies",
      description: "Our commercial trucking insurance is only available through appointed agencies specialized in trucking.",
    },
    {
      id: 3,
      value: "50k+",
      unit: "Truckers",
      description: "Sentry insures over 50,000 truck drivers.",
    },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Physical damage insurance',
      description:
        'Weather, animals, other drivers—all things that can damage your vehicle. Let us help cover your costs with physical damage insurance.',
      linkUrl: '',
      linkText: 'More about physical damage insurance >',
    },
    {
      id: 2,
      title: 'Cyber liability insurance',
      description:
        'Data breaches. While we hope they never happen to your business, they are a potential risk. Help protect your company with cyber liability coverage.',
      linkUrl: '/',
      linkText: 'More about cyber liability insurance >',
    },
    {
      id: 3,
      title: 'General liability insurance',
      description:
        'We offer protection against liability claims for your business. Coverage options include product liability, product recall, and errors and omissions.',
      linkUrl: '/',
      linkText: 'More about general liability insurance >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Trucking resources',
      description:
        'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  const ExperienceData = [
    {
      para: "Like you pride yourself in your business, we pride ourselves on our trucking insurance experience. For starters, we only appoint agencies that specialize in trucking insurance. And we don’t outsource our claims handling—all our adjusters are Sentry associates who specialize in trucking risks.",
      para1: "We’re also committed to your industry. We’re an allied member of the American Trucking Associations and several other trucking industry associations."
    }
  ]

  const AssociationData = [
    {
      image: images['ata-logo.svg'],
      para: "Understanding the transportation industry's essential role in keeping our country moving and thriving economically, we're proud to partner with the American Trucking Associations (ATA) as a Featured Product provider for eight consecutive years. Scott Miller, President of Commercial Insurance Agency and Broker at Sentry, said, “ATA has been a steadfast advocate for the trucking industry. Our continued partnership is a testament to our shared commitment to addressing industry challenges and fostering a stronger economy.” In alliance with ATA, Sentry champions the trucking sector, driving forward initiatives that benefit businesses like yours.",
      linkUrl: "",
      linkLabel: "Learn more about our partnership >",
    }
  ]

  return (
    <>
      <div className='trucking-main'>
        {/* hero section */}
        <Hero img={images["Trucking_Hero.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Trucking insurance" showshare={false} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} showImage={false} />

          {/* common list */}
          <CommonList Heading="What we offer the trucking industry:" list={Datalist} />

          {/* experience we do */}
          <PageHeaderIntro Data={ExperienceData} heading="You’ve got commercial truck experience. So do we." showImage={false} />

          {/* media video */}
          <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />

          {/* Trucking Associations */}
          <MainTextImage data={AssociationData} heading="American Trucking Associations" />

          {/* Significant figures */}
          <FigureCards data={revenueData} heading={'Significant figures'} />

          {/* products cards */}
          <NewsCard Title="Products for your trucking business" CardData={ProductCardData} showNavLink={false} subTitle="PRODUCTS" />

          {/* success stories */}
          <SuccessStories />

          {/* resources */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default TruckingInsurance